import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Signup from "./pages/Signup";
import Login from "./pages/Login";
import ForgotPassword from "./pages/ForgotPassword";
import PasswordResetConfirmation from "./pages/PasswordResetConfirmation";
import ResetPassword from "./pages/ResetPassword";
import EmailVerification from "./pages/EmailVerification";
import Onboarding from "./pages/Onboarding";
import ConnectSlack from "./pages/ConnectSlack";
import AcceptInvite from "./pages/AcceptInvite";
import Dashboard from "./pages/Dashboard";
import CreateOrganization from "./pages/CreateOrganization";
import Settings from "./pages/Settings";
import SlackTesting from "./pages/SlackTesting";
import Engagement from "./pages/Engagement";
import SentimentAnalysis from "./pages/SentimentAnalysis";
import Tone from "./pages/Tone";
import Clarity from "./pages/Clarity";
import TopicClustering from "./pages/TopicClustering";
import NetworkAnalysis from "./pages/NetworkAnalysis";
import IntegrationsCallback from "./pages/IntegrationsCallback";
import Integrations from "./pages/Integrations";
import DevTools from "./pages/DevTools";
import PrivateRoute from "./PrivateRoute";

function App() {
  return (
    <Router>
      <div>
        <Routes>
          <Route
            path="/"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route path="/signup" element={<Signup />} />
          <Route path="/login" element={<Login />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route
            path="/password-reset-confirmation"
            element={<PasswordResetConfirmation />}
          />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/email-verification" element={<EmailVerification />} />
          <Route path="/onboarding" element={<Onboarding />} />
          <Route
            path="/onboarding/connect-slack"
            element={<ConnectSlack />}
          />
          <Route path="/accept-invite" element={<AcceptInvite />} />

          <Route
            path="/settings"
            element={
              <PrivateRoute>
                <Settings />
              </PrivateRoute>
            }
          />
          <Route
            path="/testing"
            element={
              <PrivateRoute>
                <SlackTesting />
              </PrivateRoute>
            }
          />
          <Route
            path="/engagement"
            element={
              <PrivateRoute>
                <Engagement />
              </PrivateRoute>
            }
          />
          <Route
            path="/sentiment-analysis"
            element={
              <PrivateRoute>
                <SentimentAnalysis />
              </PrivateRoute>
            }
          />
          <Route
            path="/tone"
            element={
              <PrivateRoute>
                <Tone />
              </PrivateRoute>
            }
          />
          <Route
            path="/clarity"
            element={
              <PrivateRoute>
                <Clarity />
              </PrivateRoute>
            }
          />
          <Route
            path="/topic-clustering"
            element={
              <PrivateRoute>
                <TopicClustering />
              </PrivateRoute>
            }
          />
          <Route
            path="/network-analysis"
            element={
              <PrivateRoute>
                <NetworkAnalysis />
              </PrivateRoute>
            }
          />
          <Route
            path="/dev-tools"
            element={
              <PrivateRoute>
                <DevTools />
              </PrivateRoute>
            }
          />
          <Route path="/create-organization" element={<CreateOrganization />} />
          <Route path="/integrations/callback" element={<IntegrationsCallback />} />
          <Route
            path="/integrations"
            element={
              <PrivateRoute>
                <Integrations />
              </PrivateRoute>
            }
          />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
